import "../blocks/favoritesSection/favoritesSection.css";
import FavoriteCard from "./FavoriteCard";

const FavoritesSection = ({ favorites, onCreateFavorite, onDeleteFavorite }) => {
  if (!favorites) {
    return <p>Loading...</p>;
  }

  return (
    <div className="favoritesSection">
      <div className="favoritesSection__header">
        <h3 className="favoritesSection__name">My favorites</h3>
        <button
          className="favoritesSection__add-button"
          type="button"
          onClick={onCreateFavorite}
        >
          + Add new
        </button>
      </div>
      {favorites.length === 0 ? (
        <p className="favoritesSection__empty">
          Nothing saved yet. Add a photo or video link you want to keep handy.
        </p>
      ) : (
        <div className="favoritesSection__items">
          {favorites.map((favorite) => (
            <FavoriteCard
              key={favorite._id}
              favorite={favorite}
              onDelete={onDeleteFavorite}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default FavoritesSection;
